export default {
  data() {
    return {
      errores: [],
      modificado: []
    };
  },

  methods: {
    guardarError(campo, mensaje) {
      this.errores.push({ campo, mensaje });
    },

    limpiarError(campo) {
      let indice = this.errores.findIndex(e => e.campo == campo);
      if (indice != -1) {
        this.errores.splice(indice, 1);
      }
    },

    mensajeError(campo) {
      let error = this.errores.find(e => e.campo == campo);
      return error ? error.mensaje : "";
    },

    tieneError(campo) {
      if (this.modificado.indexOf(campo) != -1) {
        return this.errores.find(e => e.campo == campo) ? false : null;
      }
      return null;
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/manejoErrores.js